import React from 'react';

import {useI18n} from '@udemy/i18n';
import {Button} from '@udemy/react-core-components';

import {AT_RISK_STEP_ID, STEP_PROGRESS} from '../constants';
import {AT_RISK_HELP_CTA} from '../events';
import {StepLayout} from '../step-layout.react-component';
import styles from './response-step.module.less';

import type {StepRendererProps} from '../types';

const FALLBACK_COURSE_URL = '/home/my-courses/';

export function ALittleConfusedStep({
    dispatch,
    onClose,
    onTrackEventClick,
    lastCourseUrl,
}: StepRendererProps) {
    const {gettext} = useI18n();

    const tips = [
        gettext(
            'Take a second pass. Re-watch just the lecture where the concept is introduced - not the entire course.',
        ),
        gettext(
            'Reach out to the course community using the Q&A option. Other learners might also be confused and sharing notes sometimes helps clear.',
        ),
        gettext(
            "As a subscriber you have access to thousands of courses and each instructor's teaching style is different. Try another lecture that may help clarify things for you.",
        ),
    ];

    return (
        <StepLayout
            progressValue={STEP_PROGRESS[AT_RISK_STEP_ID.A_LITTLE_CONFUSED]}
            onClose={onClose}
            footerLeftChildren={
                <Button
                    udStyle="ghost"
                    size="medium"
                    onClick={() =>
                        dispatch({type: 'STEP_ADVANCED', nextStepId: AT_RISK_STEP_ID.INITIAL})
                    }
                >
                    {gettext('Back')}
                </Button>
            }
            footerRightChildren={
                <Button
                    udStyle="primary"
                    size="medium"
                    componentClass="a"
                    href={lastCourseUrl ?? FALLBACK_COURSE_URL}
                    onClick={() => onTrackEventClick(AT_RISK_HELP_CTA.RESUME_COURSE)}
                >
                    {gettext("I'll try that")}
                </Button>
            }
        >
            <div className={styles['content']}>
                <h2 className="ud-heading-xl">{gettext('Confusion is part of getting it.')}</h2>
                <ol className={styles['tips']}>
                    {tips.map((tip, i) => (
                        <li key={i} className="ud-text-md">
                            {tip}
                        </li>
                    ))}
                </ol>
            </div>
        </StepLayout>
    );
}
